/**
 * notification.jsx
 *
 * @Author: jruif
 * @Date: 2017/8/16 下午6:00
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import SnackbarItem from './SnackbarItem';
import { isString } from '../util/isType';

const prefix = 'ne-snackbar';
const transitionAnimate = {
  top: `${prefix}-slide-down`,
  topLeft: `${prefix}-slide-right`,
  topRight: `${prefix}-slide-left`,
  bottom: `${prefix}-slide-up`,
  bottomLeft: `${prefix}-slide-right`,
  bottomRight: `${prefix}-slide-left`,
};

/**
 * Snackbar
 * */
class SnackbarQueue extends React.Component {
  static zIndex = 10000;

  static propTypes = {
    prefixCls: PropTypes.string,
    /**
     * 打开时是否获取焦点
     * */
    autoFocus: PropTypes.bool,
    /**
     * 显示的位置
     * */
    position: PropTypes.oneOf([
      'top',
      'topLeft',
      'topRight',
      'bottom',
      'bottomLeft',
      'bottomRight',
    ]),
    /**
     * @ignore
     * */
    items: PropTypes.array,
  };

  static defaultProps = {
    prefixCls: prefix,
    position: 'top',
    autoFocus: false,
    transitionDuration: 1000,
    defaultList: [],
    max: 4,
  };

  static getDerivedStateFromProps(props, state) {
    const { defaultList } = props;
    if (defaultList !== state.prevList) {
      return {
        list: defaultList, // 存储子元素
        prevList: defaultList,
      };
    }
    return null;
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      list: props.defaultList, // 存储子元素
      prevList: props.defaultList,
    };
  }

  createKey = () => SnackbarQueue.zIndex++;

  add = props => {
    const itemID = this.createKey();
    const { max } = this.props;
    if (isString(props)) {
      props = {
        content: props,
      };
    }
    this.setState(preState => ({
      list: [{ ...props, itemID }, ...preState.list].slice(0, max),
    }));
    // 方便定位具体notice item调用
    return itemID;
  };

  update = (itemID, props) => {
    if (isString(props)) {
      props = {
        content: props,
      };
    }
    this.setState(preState => ({
      list: preState.list.map(item => (item.itemID === itemID ? props : item)),
    }));
  };

  destroyItem = itemID => {
    this.setState(({ list }) => ({
      list: list.filter(item => item.itemID !== itemID),
    }));
  };

  render() {
    const { prefixCls, position, transitionDuration, ...otherProps } = this.props;
    const { list } = this.state;
    const transitionName = transitionAnimate[position];
    const classes = classNames(
      prefixCls,
      [`${prefixCls}-position-${position}`],
      [`${prefixCls}-queue-${position.includes('top') ? 'top' : 'bottom'}`],
    );
    return (
      <div className={classes}>
        <TransitionGroup appear>
          {list.map(({ itemID, style, ...other }) => (
            <CSSTransition classNames={transitionName} key={itemID} timeout={transitionDuration}>
              <SnackbarItem
                {...otherProps}
                {...other}
                id={itemID}
                key={itemID}
                onClose={this.destroyItem}/>
            </CSSTransition>
          ))}
        </TransitionGroup>
      </div>
    );
  }
}

export default SnackbarQueue;



// WEBPACK FOOTER //
// ./src/snackbar/SnackbarQueue.jsx